import * as React from "react";

import { cn } from "@roqua/components/lib/utils";
import { Select, SelectContent, SelectTrigger, SelectValue } from "@roqua/components/ui/select";

interface SelectWithLabelProps {
  label: string;
  placeholder?: string;
  value?: string;
  onValueChange?: (value: string) => void;
  children: React.ReactNode;
  className?: string;
  disabled?: boolean;
}

export const SelectWithLabel = React.forwardRef<
  React.ElementRef<typeof SelectTrigger>,
  SelectWithLabelProps
>(({ label, placeholder, value, onValueChange, children, className, disabled, ...props }, ref) => {
  const labelId = React.useId();
  
  return (
    <Select value={value} onValueChange={onValueChange} disabled={disabled}>
      <SelectTrigger ref={ref} className={cn("h-12 px-3 py-2", className)} aria-labelledby={labelId} {...props}>
        <div className="flex w-full items-center gap-2">
          <span id={labelId} className="text-muted-foreground whitespace-nowrap text-sm font-medium">
            {label}:
          </span>
          <SelectValue placeholder={placeholder} className="text-sm font-normal" />
        </div>
      </SelectTrigger>
      <SelectContent className="w-[var(--radix-select-trigger-width)]">{children}</SelectContent>
    </Select>
  );
});

SelectWithLabel.displayName = "SelectWithLabel";
